import { NgModule } from "@angular/core";
import { PhxLinkComponent } from "./phx-link.component";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [PhxLinkComponent],
  exports: [PhxLinkComponent]
})
export class PhxLinkModule {}
